
window.DIGISTORE_KEEP_AFFILIATEIN_LOCATION_HREF = false;
